import { Box, Grid } from '@mui/material';

import { InfoField, NO_DATA_PLACEHOLDER } from '@occc-app/design-system';
import { MembershipAddressFragment } from '@occc/graphql';

type MemberPrimaryAddressFieldsProps = {
  address: MembershipAddressFragment;
};

type MemberDetailsField = {
  name: string;
  attribute: keyof MembershipAddressFragment;
  defaultValue: string;
};

const fields: MemberDetailsField[] = [
  {
    name: 'Address 1',
    attribute: 'address1',
    defaultValue: NO_DATA_PLACEHOLDER,
  },
  {
    name: 'City',
    attribute: 'city',
    defaultValue: NO_DATA_PLACEHOLDER,
  },
  {
    name: 'State',
    attribute: 'state',
    defaultValue: NO_DATA_PLACEHOLDER,
  },
  {
    name: 'Zipcode',
    attribute: 'zipcode',
    defaultValue: NO_DATA_PLACEHOLDER,
  },
];

const MemberPrimaryAddressFields = ({ address }: MemberPrimaryAddressFieldsProps) => {
  return (
    <Box>
      <Grid container spacing={3}>
        {fields.map((field) => {
          const value = address?.[field.attribute]?.toString();
          return (
            <Grid item xs={12} md={3} key={field.attribute}>
              <InfoField label={field.name} value={value || field.defaultValue} />
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default MemberPrimaryAddressFields;
